(() => {
  const TRIGGER_SELECTOR = ".mox-btn-popup";
  const FORM_ROOT_SELECTOR = '[data-forms-id="forms-root-871265"]';

  document.addEventListener("DOMContentLoaded", () => {
    const formRoot = document.querySelector(FORM_ROOT_SELECTOR);
    if (!formRoot) return;

    let lastTrigger = null;

    const dialog = document.createElement("dialog");
    dialog.id = "custom-forms-modal";
    dialog.setAttribute("aria-labelledby", "custom-forms-modal-title");
    dialog.setAttribute("aria-describedby", "custom-forms-modal-desc");

    const modalContent = document.createElement("div");
    modalContent.className = "mox-modal__content";

    const title = document.createElement("h2");
    title.id = "custom-forms-modal-title";
    title.className = "mox-modal__title";
    title.textContent = "Formulario de contacto";

    const desc = document.createElement("p");
    desc.id = "custom-forms-modal-desc";
    desc.className = "mox-modal__title";
    desc.textContent = "Completa los campos para comunicarte con nosotros.";

    const closeBtn = document.createElement("button");
    closeBtn.type = "button";
    closeBtn.className = "mox-modal__close";
    closeBtn.setAttribute("aria-label", "Cerrar");
    closeBtn.innerHTML = "&times;";

    function closeModal() {
      dialog.close();
      document.body.style.overflow = "";
      if (lastTrigger) lastTrigger.focus();
    }

    function openModal(trigger) {
      lastTrigger = trigger;
      document.body.style.overflow = "hidden";
      dialog.showModal();
    }

    closeBtn.addEventListener("click", closeModal);

    dialog.addEventListener("cancel", (e) => {
      e.preventDefault();
      closeModal();
    });

    // Cerrar al hacer click en el backdrop (fuera del contenido)
    dialog.addEventListener("click", (e) => {
      if (e.target === dialog) closeModal();
    });

    modalContent.appendChild(title);
    modalContent.appendChild(desc);
    modalContent.appendChild(closeBtn);
    modalContent.appendChild(formRoot);
    dialog.appendChild(modalContent);
    document.body.appendChild(dialog);

    document.addEventListener("click", (event) => {
      const trigger = event.target.closest(TRIGGER_SELECTOR);
      if (!trigger) return;
      event.preventDefault();
      openModal(trigger);
    });
  });
})();
